import { removeEmptyFields } from "utils";
import { RequiredParamException } from "../exceptions/InvalidParamException";
import { IIntegrationSetup } from "../interfaces";
import CompanyModel from "../models/CompanyModel";
import CompanyRepository from "../repositories/CompanyRepository";
import { markFieldToDelete } from "../repositories/FirebaseRepository";
import AuthService from "./AuthService";

class CompanyService {
  async createCompany(company: CompanyModel) {
    if (!company.name) throw new RequiredParamException("name");
    return CompanyRepository.addCompanyToDataBase(company);
  }

  updateCompanyLogo(company: CompanyModel) {
    let image = company.image;
    if (!image) image = markFieldToDelete();

    return CompanyRepository.updateCompanyOnDataBase(company.uid, {
      image,
    });
  }

  updateCompany(company: CompanyModel) {
    if (!company.name) throw new RequiredParamException("name");

    let image = company.image;
    if (!image) image = markFieldToDelete();

    return CompanyRepository.updateCompanyOnDataBase(company.uid, {
      name: company.name,
      image,
    });
  }

  async updateIntegrationSetup(
    uid: string,
    integrationSetup: IIntegrationSetup
  ): Promise<void> {
    integrationSetup = removeEmptyFields(integrationSetup);
    if (Object.keys(integrationSetup).length === 1) {
      integrationSetup = markFieldToDelete();
    }

    return CompanyRepository.updateCompanyOnDataBase(uid, {
      integrationSetup,
    });
  }

  subscribeCompanySnapshotByUser(onChange: (data?: CompanyModel) => void) {
    if (!AuthService.isAuthenticated) return;

    const authUid = AuthService.currentUserId;
    return CompanyRepository.addCompanyDocumentSnapshot(authUid, onChange);
  }
}

export default new CompanyService();
